import { render, staticRenderFns } from "./CheckboxQuestion.vue?vue&type=template&id=51074451"
import script from "./CheckboxQuestion.vue?vue&type=script&lang=js"
export * from "./CheckboxQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports